import { Splide } from '@splidejs/splide';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

export default function (isSimple) {
    const mainGalleryConfig = {
        type: 'fade',
        rewind: true,
        pagination: false,
        arrows: false
    };

    const thumbnailConfig = {
        fixedWidth: 64,
        fixedHeight: 64,
        gap: 16,
        rewind: true,
        pagination: false,
        isNavigation: true,
        perPage: 5,
        lazyLoad: 'nearby',
        breakpoints: {
            768: {
                fixedWidth: 48,
                fixedHeight: 48,
                focus: 'center',
                perPage: 4,
                arrows: false,
                gap: 8
            }
        }
    };

    return {
        isSimpleType: isSimple,
        init() {
            if (!this.isSimpleType) {
                this.initNormalMode();
            }
            this.modalProductGallery();
        },

        initNormalMode() {
            this.gallerySlider = new Splide(
                '#main-carousel',
                mainGalleryConfig
            );
            this.navSlider = new Splide('#thumbnail-carousel', thumbnailConfig);
            this.gallerySlider.on('hidden', (slide) => {
                const focused = document.activeElement;
                if (focused && slide.slide.contains(focused)) {
                    focused.blur(); // Prevent hidden-focused conflict
                }

                slide.slide.setAttribute('inert', ''); // Prevent focus and hide from AT
            });

            this.gallerySlider.on('visible', (slide) => {
                slide.slide.removeAttribute('inert');
            });
            this.gallerySlider.sync(this.navSlider);
            this.gallerySlider.mount();
            this.navSlider.mount();
        },

        modalProductGallery() {
            Fancybox.bind('[data-fancybox]', {
                theme: 'light',
                on: {
                    'Carousel.contentReady': (
                        fancyboxRef,
                        carouselRef,
                        slide
                    ) => {
                        this.gallerySlider.go(slide.index);
                    }
                },
                Images: {
                    zoom: false
                },
                showClass: 'f-fadeIn',
                hideScrollbar: true
            });
        }
    };
}
